import { Settings, Users, CreditCard, Server } from 'lucide-react';
import { Outlet, useParams, useLocation } from 'react-router';

import { Page, PageBody } from './page';
import { PageSidebar } from './page-sidebar';

const navItems = [
    { title: 'General', icon: Settings, path: 'general' },
    { title: 'Members', icon: Users, path: 'members' },
    { title: 'Gateways', icon: Server, path: 'gateways' },
    { title: 'Billing', icon: CreditCard, path: 'billing' },
];

export function SettingsLayout() {
    const { tenantId } = useParams<{ tenantId: string }>();
    const location = useLocation();

    const basePath = `/settings/tenant/${tenantId}`;
    const casesPath = `/tenants/${tenantId}`;

    const isActive = (path: string) => {
        const fullPath = `${basePath}/${path}`;
        return location.pathname === fullPath || (path === 'general' && location.pathname === basePath);
    };

    return (
        <Page>
            <PageBody scroll="y">
                <div className="flex flex-col md:flex-row md:gap-6">
                    <PageSidebar
                        title="Settings"
                        navItems={navItems}
                        basePath={basePath}
                        backLink={{ label: 'Back to Cases', href: casesPath }}
                        isActive={isActive}
                    />
                    <div className="flex-1 min-w-0">
                        <Outlet />
                    </div>
                </div>
            </PageBody>
        </Page>
    );
}
